import InfoOverlay from './InfoOverlay'

export default InfoOverlay
